(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["jffd-feeding-link"] && !Shopify.designMode) return;
  try {
    (function () {
    var JFFD_PDP_QUIZ_GUID = 'b5975d3b-61cb-4cc1-9b15-26b81d3d7baa'; // Digioh box 333486
    var JFFD_PDP_EDIT_GUID = '1044f9e3-8ba1-440e-819b-8aa13d218852'; // Digioh box 334877

    function assignDefined(base, extra) {
      var out = Object.assign({}, base || {});
      Object.keys(extra || {}).forEach(function (key) {
        if (extra[key] !== '' && extra[key] != null) out[key] = extra[key];
      });
      return out;
    }

    function storedQuizPayload() {
      var stored = {};
      var handleStored = {};
      var handle = '';
      try {
        var node = document.querySelector('[data-jffd-pdp-quiz-pack]');
        if (node) handle = JSON.parse(node.textContent).handle || '';
      } catch (e) {}
      try { stored = JSON.parse(window.localStorage.getItem('jffd-pdp-quiz:pet') || 'null') || {}; } catch (e) {}
      try {
        if (handle) {
          handleStored = JSON.parse(window.localStorage.getItem('jffd-pdp-quiz:' + handle) || 'null') || {};
        }
      } catch (e) {}
      return assignDefined(stored, handleStored);
    }

    function loadJffdPdpBox(guid, dataLayer) {
      var tries = 0;
      (function attempt() {
        if (window.DIGIOH_API && window.DIGIOH_API.LIGHTBOX && typeof window.DIGIOH_API.LIGHTBOX.loadLightbox === 'function') {
          if (dataLayer && typeof window.DIGIOH_API.setDataLayer === 'function') {
            // Keep explicit empty values: reopening Edit Pet for a different dog
            // must clear fields the previous dog had but this one does not.
            window.DIGIOH_API.setDataLayer(dataLayer);
          }
          window.DIGIOH_API.LIGHTBOX.loadLightbox(guid);
          return;
        }
        tries += 1;
        if (tries < 80) setTimeout(attempt, 100);
      })();
    }

    function openJffdPdpQuiz(e) {
      if (e) e.preventDefault();
      // Clear every edit-scoped key, not just the mode flag. The Digioh data layer is
      // account-wide and persisted, so a pet id left over from a previous Edit Pet would
      // ride along into this new dog's submission and make it look like an edit.
      loadJffdPdpBox(JFFD_PDP_QUIZ_GUID, {
        jffd_edit_mode: '',
        jffd_edit_nonce: '',
        jffd_edit_logged_in: '',
        jffd_edit_pet_id: '',
        custom_54: ''
      });
    }

    function bind() {
      var trigger = document.getElementById('jffd-feeding-quiz-link');
      if (trigger) trigger.addEventListener('click', openJffdPdpQuiz);
    }

    window.__jffdOpenPdpQuizForEdit = function (context) {
      context = context || {};
      var normalize = window.__jffdNormalizePdpEditPayload;
      var incoming = context.payload || context || {};
      // A logged-in pet must never inherit another pet's browser-only quiz answers.
      var merged = context.mode === 'logged-in' && context.petId
        ? incoming
        : assignDefined(storedQuizPayload(), incoming);
      var payload = typeof normalize === 'function' ? normalize(merged) : merged;
      var nonce = window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : String(Date.now()) + '-' + String(Math.random()).slice(2);
      window.__jffdPdpEditNonce = nonce;
      loadJffdPdpBox(JFFD_PDP_EDIT_GUID, {
        jffd_edit_mode: '1',
        jffd_edit_nonce: nonce,
        jffd_edit_logged_in: context.mode === 'logged-in' ? '1' : '0',
        jffd_edit_pet_id: context.petId || '',
        // 2026-09-18: the same pet id again, in a custom_N slot. jffd_edit_pet_id is a bare
        // data-layer key, so it reaches Custom JS but never arrives in the Digioh form
        // submission, which only carries custom_N. A Connect pipeline that writes a pet
        // snapshot has to name the pet it is writing to, so the id has to travel this way.
        // custom_54 is the first free slot (53 is the Shopify customer GID, set by snippet
        // 26168). Harmless on its own: nothing reads it until the snapshot pipeline does.
        custom_54: context.petId || '',
        custom_3: payload.dogName || '',
        custom_6: payload.sex || '',
        custom_7: payload.neutered || '',
        custom_10: payload.activity || '',
        custom_11: payload.weight || '',
        custom_41: payload.birthMonth || '',
        custom_42: payload.birthYear || '',
        custom_43: payload.bodyType || '',
        custom_44: payload.portion || 'full-bowl',
        custom_45: payload.calories || ''
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind);
    } else {
      bind();
    }
  })();

  (function () {
    var PREFERRED_PACK = 21;
    var MIN_DAYS = 7;
    var MAX_WEEKS = 12;
    var MAX_DAYS = MAX_WEEKS * 7;

    function parsePackInfo(variant) {
      var mfOz = Number(variant && variant.ozPerPack) || 0;
      var mfCount = Number(variant && (variant.packUnits || variant.packCount)) || 0;
      if (mfOz > 0 && mfCount > 0) return { ozPerPack: mfOz, packCount: mfCount };

      var text = [variant && variant.weightLabel, variant && variant.title].filter(Boolean).join(' ').replace(/×/g, 'x');
      var casePackMatch = text.match(/\(?([\d]+)\)?\s*x\s*([\d.]+)\s*[- ]?oz/i);
      var ozMatch = text.match(/([\d.]+)\s*[- ]?oz/i);
      var packMatch = text.match(/\(?([\d]+)\)?\s*(?:[\d.]+\s*[- ]?oz\s*)?packs?/i);
      var ozPerPack = mfOz > 0 ? mfOz : (casePackMatch ? parseFloat(casePackMatch[2]) : (ozMatch ? parseFloat(ozMatch[1]) : 0));
      var packCount = mfCount > 0 ? mfCount : (casePackMatch ? parseInt(casePackMatch[1], 10) : (packMatch ? parseInt(packMatch[1], 10) : 0));

      /* Last resort: custom.size as TOTAL ounces for the box.

         This is what rescues JustFresh on the PDP, the same way it already does on the
         results page (sections/digioh-results.liquid, commit 1964a4f, 2026-09-15). Its
         titles carry a pack count and no ounces ("JustFresh Home-Cooked Beef (7 Pack)")
         and oz_per_pack is empty catalog-wide, so both paths above return 0. custom.size
         holds 84 / 168 / 253 / 336 for the 7 / 14 / 21 / 28 packs, which is the whole box
         in ounces at 12 oz per pouch.

         Deliberately last, because the field is not trustworthy across the catalog. On
         Fresh Frozen some variants hold a correct total (252 for 18 oz x 14) and others
         hold 3, which is not ounces of anything. Fresh Frozen never reaches this branch,
         since its titles do carry ounces and ozPerPack is already set by then, so the bad
         values stay harmless.

         The sanity gate is what makes it safe for any line whose data has not been
         verified, Pantry Fresh included: a derived per-pack weight below 1 oz or above
         200 oz is treated as a broken field and ignored, leaving the old behaviour intact. */
      if (!ozPerPack && packCount > 0) {
        var totalOz = Number(variant && variant.size) || 0;
        var derived = totalOz / packCount;
        if (derived >= 1 && derived <= 200) {
          ozPerPack = derived;
        }
      }

      return { ozPerPack: ozPerPack, packCount: packCount };
    }

    function portionMultiplier(portion) {
      var key = String(portion || '').toLowerCase();
      if (key.indexOf('half') !== -1) return 0.5;
      if (key.indexOf('top') !== -1) return 0.25;
      return 1;
    }

    function foodCaloriesFrom(data) {
      var listed = parseFloat(data && data.foodCalories);
      if (listed) return listed;
      var v = data && data.variants && data.variants[0];
      if (!v || !v.kcal) return 0;
      var pack = parsePackInfo(v);
      if (!pack.ozPerPack) return 0;
      return v.kcal / pack.ozPerPack;
    }

    function pickPack(data, dailyCalories, multiplier) {
      var fallback = { variant: (data.variants && data.variants[0]) || null, days: 0, reason: 'no-pack-data' };
      var foodCalories = foodCaloriesFrom(data);
      var ozPerDay = (dailyCalories && foodCalories) ? (dailyCalories / foodCalories) * (multiplier || 1) : 0;
      if (!ozPerDay || !data.variants || !data.variants.length) return fallback;

      var candidates = data.variants
        .filter(function (v) { return v.available !== false; })
        .map(function (v) {
          var pack = parsePackInfo(v);
          var totalOz = pack.ozPerPack * pack.packCount;
          return { variant: v, packCount: pack.packCount, totalOz: totalOz, days: totalOz ? totalOz / ozPerDay : 0 };
        })
        .filter(function (c) { return c.days > 0; });
      if (!candidates.length) return fallback;

      var chosen;
      var reason;
      var preferred = candidates.filter(function (c) {
        return c.packCount === PREFERRED_PACK;
      }).sort(function (a, b) { return a.totalOz - b.totalOz; })[0];

      if (preferred && preferred.days >= MIN_DAYS && preferred.days <= MAX_DAYS) {
        chosen = preferred;
        reason = 'preferred-pack';
      } else if (preferred && preferred.days < MIN_DAYS) {
        var stepUp = candidates.filter(function (c) {
          return c.totalOz > preferred.totalOz && c.days >= MIN_DAYS;
        }).sort(function (a, b) { return a.totalOz - b.totalOz; });
        if (stepUp.length) { chosen = stepUp[0]; reason = 'stepped-up'; }
      } else if (preferred && preferred.days > MAX_DAYS) {
        var stepDown = candidates.filter(function (c) {
          return c.totalOz < preferred.totalOz && c.days >= MIN_DAYS && c.days <= MAX_DAYS;
        }).sort(function (a, b) { return b.totalOz - a.totalOz; });
        if (stepDown.length) { chosen = stepDown[0]; reason = 'stepped-down'; }
      }

      if (!chosen) {
        var inRange = candidates.filter(function (c) {
          return c.days >= MIN_DAYS && c.days <= MAX_DAYS;
        });
        if (inRange.length) {
          inRange.sort(function (a, b) { return b.totalOz - a.totalOz; });
          chosen = inRange[0];
          reason = preferred ? 'closest-valid-fallback' : 'preferred-unavailable';
        }
      }
      if (!chosen) {
        var safe = candidates.filter(function (c) { return c.days >= MIN_DAYS; });
        if (safe.length) {
          safe.sort(function (a, b) { return a.totalOz - b.totalOz; });
          chosen = safe[0];
          reason = 'minimum-supply-fallback';
        }
      }
      if (!chosen) {
        candidates.sort(function (a, b) { return b.totalOz - a.totalOz; });
        chosen = candidates[0];
        reason = 'below-minimum-largest-available';
      }

      return { variant: chosen.variant, days: chosen.days, packCount: chosen.packCount, reason: reason };
    }

    function selectVariant(variantId) {
      if (!variantId) return false;
      var input = document.querySelector(
        'variant-picker input[data-variant-id="' + variantId + '"]'
      );
      if (!input) return false;
      if (input.checked) return true;
      input.click();
      return !!input.checked;
    }

    function planWeeksFromLabel(text) {
      var name = String(text || '').toLowerCase();
      var m = name.match(/(\d+)\s*(day|week|month)/);
      if (m) {
        var n = parseInt(m[1], 10);
        if (m[2] === 'week') return n;
        if (m[2] === 'day') return n / 7;
        if (m[2] === 'month') return n * 4;
      }
      if (name.indexOf('every other week') !== -1 || name.indexOf('biweekly') !== -1) return 2;
      if (name.indexOf('every week') !== -1 || name.indexOf('weekly') !== -1) return 1;
      return 0;
    }

    // Longest plan that does not outlast the pack, else the shortest plan.
    function pickPlan(plans, weeks) {
      var scored = plans.filter(function (p) { return p.weeks > 0; });
      if (!scored.length) return null;
      var safe = scored.filter(function (p) { return p.weeks <= weeks; });
      return (safe.length
        ? safe.sort(function (a, b) { return b.weeks - a.weeks; })
        : scored.sort(function (a, b) { return a.weeks - b.weeks; }))[0];
    }

    /* 2026-09-23, first live bug after launch: the quiz said "every 8 weeks" but the
       Subscribe & Save dropdown stayed on "1 week (recommended)". Standard PDPs render
       Ordergroove's own <og-offer> app block. Only the bundle template renders the theme's
       .jffd-selling-plan-selector, so on every other PDP the lookup found no select and
       quietly returned false.

       OG keeps a frequency per variant. The first time it sees a variant it applies its own
       1-week default, about a second after the variant swap. Setting the plan any earlier
       gets overwritten. So wait until OG has registered the chosen variant, then set the
       plan through OG's store, which also moves the visible dropdown and the form's
       selling_plan input. A shopper who chose Ship Once for this variant is left alone. */
    function selectOgSellingPlan(planId, variantId) {
      var store = window.OG && window.OG.store;
      if (!store || typeof store.subscribe !== 'function') return false;
      var id = String(variantId || '');
      var plan = String(planId);

      function entryFor(list) {
        return (list || []).filter(function (p) { return String(p.id) === id; })[0];
      }
      // The offer element once OG shows this variant and has opted it in or out, else null.
      function readyOffer() {
        var offer = document.querySelector('og-offer[location="pdp"]');
        if (!offer || offer.getAttribute('product') !== id) return null;
        var state = store.getState();
        return entryFor(state.optedin) || entryFor(state.optedout) ? offer : null;
      }
      function apply(offer) {
        var optedIn = entryFor(store.getState().optedin);
        if (!optedIn || String(optedIn.frequency) === plan) return;
        store.dispatch({
          type: 'PRODUCT_CHANGE_FREQUENCY',
          payload: { product: { id: id }, frequency: plan, offer: offer }
        });
      }

      var offer = readyOffer();
      if (offer) {
        apply(offer);
        return true;
      }
      var timer;
      var unsubscribe = store.subscribe(function () {
        var ready = readyOffer();
        if (!ready) return;
        unsubscribe();
        clearTimeout(timer);
        apply(ready);
      });
      // OG registers a swapped variant in about a second. Stop listening after 10s so a
      // shopper's own later change is never overridden.
      timer = setTimeout(unsubscribe, 10000);
      return true;
    }

    function selectSellingPlan(targetWeeks, variantId, sellingPlans) {
      var weeks = Math.floor(Number(targetWeeks) || 0);
      if (weeks < 1) weeks = 1;
      if (weeks > 12) weeks = 12;

      var select = document.querySelector('.jffd-selling-plan-selector select[name="selling_plan"]');
      if (!(select instanceof HTMLSelectElement) || !select.options.length) {
        var ogPlan = pickPlan((sellingPlans || []).map(function (p) {
          return { id: p.id, weeks: planWeeksFromLabel(p.name) };
        }), weeks);
        return ogPlan && variantId ? selectOgSellingPlan(ogPlan.id, variantId) : false;
      }

      var subscribe = document.querySelector('.jffd-selling-plan-selector input[value="subscription"]');
      if (subscribe instanceof HTMLInputElement && !subscribe.checked) subscribe.click();

      var options = [];
      for (var i = 0; i < select.options.length; i++) {
        options.push({ option: select.options[i], weeks: planWeeksFromLabel(select.options[i].textContent) });
      }
      var chosen = pickPlan(options, weeks);
      if (!chosen) return false;
      if (select.value !== chosen.option.value) {
        select.value = chosen.option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }

    function storageKey(handle) {
      return 'jffd-pdp-quiz:' + String(handle || '');
    }

    function normalizeQuizPayload(payload) {
      payload = payload || {};
      return {
        calories: payload.calories || payload.custom_45 || '',
        portion: payload.portion || payload.custom_44 || 'full-bowl',
        dogName: payload.dogName || payload.custom_3 || '',
        weight: payload.weight || payload.custom_11 || '',
        activity: payload.activity || payload.custom_10 || '',
        neutered: payload.neutered || payload.custom_7 || '',
        bodyType: payload.bodyType || payload.custom_43 || '',
        birthMonth: payload.birthMonth || payload.custom_41 || '',
        birthYear: payload.birthYear || payload.custom_42 || '',
        sex: payload.sex || payload.custom_6 || '',
        ageGroup: payload.ageGroup || payload.custom_46 || '',
        breed: payload.breed || '',
        boxId: payload.boxId || '333486'
      };
    }

    function applyPdpQuizResult(rawPayload, options) {
      var payload = normalizeQuizPayload(rawPayload);
      window.jffdPdpQuizLastLayer = payload;
      var node = document.querySelector('[data-jffd-pdp-quiz-pack]');
      if (!node) return { ok: false, reason: 'no-pack-data' };
      var data;
      try { data = JSON.parse(node.textContent); } catch (e) { return { ok: false, reason: 'bad-pack-json' }; }
      var calories = parseFloat(payload.calories);
      var choice = calories ? pickPack(data, calories, portionMultiplier(payload.portion)) : {};
      var swapped = choice.variant ? selectVariant(choice.variant && choice.variant.id) : false;
      var weeks = Math.floor((choice.days || 0) / 7);
      if (weeks < 1) weeks = 1;
      if (weeks > 12) weeks = 12;
      var planSet = calories ? selectSellingPlan(weeks, choice.variant && choice.variant.id, data.sellingPlans) : false;
      var result = {
        ok: Boolean(payload.dogName || calories),
        variantId: choice.variant && choice.variant.id,
        packCount: choice.packCount,
        days: choice.days,
        weeks: weeks,
        planSet: planSet,
        dogName: payload.dogName,
        calories: calories || 0,
        reason: swapped ? choice.reason : (choice.reason || (calories ? 'variant-click-missed' : 'no-calories'))
      };
      window.jffdPdpQuizLastApply = result;
      try {
        window.localStorage.setItem('jffd-pdp-quiz:pet', JSON.stringify(payload));
        if (data.handle) {
          window.localStorage.setItem(storageKey(data.handle), JSON.stringify({
            calories: payload.calories,
            portion: payload.portion,
            dogName: payload.dogName,
            variantId: result.variantId,
            packCount: result.packCount,
            days: result.days,
            weeks: weeks
          }));
        }
      } catch (e) {}
      if (!(options && options.skipCard) && typeof window.__jffdShowQuizRecommendation === 'function') {
        window.__jffdShowQuizRecommendation(payload, {
          openDialog: !(options && options.skipDialog),
          packCount: result.packCount,
          days: result.days,
          weeks: weeks,
          variantTitle: choice.variant && choice.variant.title
        });
      }
      return result;
    }

    window.__jffdApplyPdpQuizResult = applyPdpQuizResult;

    // Reuse the full quiz's pack ladder when a logged-in shopper switches pets.
    // This path only changes the PDP variant/plan; it does not overwrite the
    // guest quiz's shared localStorage record with another pet's details.
    window.__jffdSelectPdpPackForPet = function (dailyCalories, portion) {
      var node = document.querySelector('[data-jffd-pdp-quiz-pack]');
      if (!node) return { ok: false, reason: 'no-pack-data' };
      var data;
      try { data = JSON.parse(node.textContent); } catch (e) { return { ok: false, reason: 'bad-pack-json' }; }
      var calories = Number(dailyCalories);
      if (!(calories > 0)) return { ok: false, reason: 'no-calories' };
      var choice = pickPack(data, calories, portionMultiplier(portion));
      if (!choice.variant) return { ok: false, reason: choice.reason || 'no-variant' };
      var swapped = selectVariant(choice.variant.id);
      var weeks = Math.max(1, Math.min(12, Math.floor((choice.days || 0) / 7)));
      var planSet = selectSellingPlan(weeks, choice.variant.id, data.sellingPlans);
      var result = {
        ok: swapped,
        variantId: choice.variant.id,
        packCount: choice.packCount,
        days: choice.days,
        weeks: weeks,
        planSet: planSet,
        reason: swapped ? choice.reason : 'variant-click-missed'
      };
      window.jffdPdpPetLastPackApply = result;
      return result;
    };

    window.addEventListener('message', function (event) {
      var data = event && event.data;
      if (!data || data.source !== 'jffd-pdp-quiz') return;
      /* 2026-09-18: this used to call packConfig(), which is declared in the NEXT IIFE and
         is therefore not in scope here. Every quiz completion threw
         "ReferenceError: packConfig is not defined" on this line, so the handler died
         before reaching applyPdpQuizResult and nothing downstream ran: no pack selection,
         no selling plan, no dog pill. Read the node directly so this listener does not
         depend on another closure's internals. */
      var pack = {};
      try {
        var packNode = document.querySelector('[data-jffd-pdp-quiz-pack]');
        if (packNode) pack = JSON.parse(packNode.textContent) || {};
      } catch (e) {}
      var isExistingPetEdit =
        data.mode === 'edit' &&
        String(data.boxId || '') === '334877';
      if (pack.loggedIn && isExistingPetEdit && typeof window.__jffdSaveLoggedInPetEdit === 'function') {
        // Logged-in edit: __jffdSaveLoggedInPetEdit owns applying the
        // result (pack, plan, pill) and only does so once the API confirms
        // the save, so nothing runs here until then.
        window.__jffdSaveLoggedInPetEdit(data);
        return;
      }
      applyPdpQuizResult(data, { skipDialog: true });
    });
  })();

  /* ---------------------------------------------------------------------
     After Campaign 333486 (or the main quiz) completes, the Digioh data
     layer is the source of truth: custom_3 = pet name, custom_45 = calories.
     Show that pet on the PDP. Hide the RunDTC account card so Gloria from
     the Partner API does not replace the quiz pet.
     --------------------------------------------------------------------- */
  (function () {
    function formatCups(cupsPerDay) {
      var rounded = Math.round(cupsPerDay * 10000) / 10000;
      var whole = Math.floor(rounded);
      var frac = rounded - whole;

      var fraction = '';
      if (frac >= 0.0625 && frac <= 0.3124) fraction = '1/4';
      else if (frac >= 0.3125 && frac <= 0.4374) fraction = '3/8';
      else if (frac >= 0.4375 && frac <= 0.5624) fraction = '1/2';
      else if (frac >= 0.5625 && frac <= 0.6874) fraction = '5/8';
      else if (frac >= 0.6875 && frac <= 0.8124) fraction = '3/4';
      else if (frac >= 0.8125 && frac <= 0.9374) fraction = '7/8';
      else if (frac >= 0.9375) fraction = '1';

      if (fraction === '1') return String(Math.round(rounded));
      if (fraction === '') return String(whole);
      if (whole === 0) return fraction;
      return whole + ' ' + fraction;
    }

    function formatTimeframe(days) {
      if (!days) return 'a week';
      if (days >= 6.5 && days < 8) return 'a week';
      var weeks = Math.floor(days / 7);
      if (weeks >= 2) return weeks + ' weeks';
      return Math.round(days) + ' days';
    }

    function packLabel(packCount, title) {
      if (packCount) return packCount + '-pack';
      return String(title || 'box').toLowerCase();
    }

    function packConfig() {
      var node = document.querySelector('[data-jffd-pdp-quiz-pack]');
      if (!node) return {};
      try { return JSON.parse(node.textContent); } catch (e) { return {}; }
    }

    function setLoggedInPetCardHidden(hide) {
      var host = document.querySelector('pet-feeding-details');
      if (host) host.hidden = hide;
    }

    function bindGuestAddLink(data) {
      var addEl = document.querySelector('[data-jffd-quiz-guest-add]');
      if (!addEl) return;
      addEl.href = data.addPetUrl || data.registerUrl || '/account/register';
      if (data.addPetOpenInNewTab) {
        addEl.target = '_blank';
        addEl.rel = 'noopener';
      } else {
        addEl.removeAttribute('target');
        addEl.removeAttribute('rel');
      }
    }

    function feedingNumbers(payload, data) {
      var calories = parseFloat(payload && payload.calories) || 0;
      var petName = (payload && payload.dogName) || 'your dog';
      var ozPerDay = (calories && data.foodCalories) ? Math.ceil(calories / data.foodCalories) : 0;
      var cupsDisplay = data.cupsToOz > 0 && ozPerDay > 0 ? formatCups(ozPerDay / data.cupsToOz) : '';
      var sentence = petName + ' needs ' + (calories ? Math.round(calories) : '—') + ' calories per day.';
      if (cupsDisplay && ozPerDay) {
        sentence += ' That is ' + cupsDisplay + ' cups (' + ozPerDay + ' oz) of this recipe.';
      }
      return {
        petName: petName,
        calories: calories ? Math.round(calories) : 0,
        caloriesLabel: calories ? String(Math.round(calories)) : '—',
        ozPerDay: ozPerDay,
        ozLabel: ozPerDay ? String(ozPerDay) : '—',
        cupsDisplay: cupsDisplay || '—',
        sentence: sentence
      };
    }

    function fillGuestPopup(payload, data) {
      var nums = feedingNumbers(payload, data);
      var headingEl = document.querySelector('[data-jffd-quiz-guest-heading]');
      var sentenceEl = document.querySelector('[data-jffd-quiz-guest-sentence]');
      var calEl = document.querySelector('[data-jffd-quiz-guest-cal]');
      var cupsEl = document.querySelector('[data-jffd-quiz-guest-cups]');
      var ozEl = document.querySelector('[data-jffd-quiz-guest-oz]');
      if (headingEl) headingEl.textContent = nums.petName;
      if (sentenceEl) sentenceEl.textContent = nums.sentence;
      if (calEl) calEl.textContent = nums.caloriesLabel;
      if (cupsEl) cupsEl.textContent = nums.cupsDisplay;
      if (ozEl) ozEl.textContent = nums.ozLabel;
      window.jffdPdpQuizLastNumbers = nums;
      return nums;
    }

    function openGuestDialog() {
      var dialog = document.getElementById('jffd-pdp-quiz-guest-dialog');
      if (!dialog) return;
      fillGuestPopup(window.jffdPdpQuizLastLayer || {}, packConfig());
      dialog.hidden = false;
    }

    function closeGuestDialog() {
      var dialog = document.getElementById('jffd-pdp-quiz-guest-dialog');
      if (dialog) dialog.hidden = true;
    }

    function setQuizLinkHidden(hide) {
      var link = document.getElementById('jffd-feeding-quiz-link');
      if (!link) return;
      link.hidden = hide;
      link.style.display = hide ? 'none' : '';
    }

    function showGuestRecommendation(payload, extras, data, openDialog) {
      var guest = document.getElementById('jffd-pdp-quiz-guest');
      var nameEl = document.querySelector('[data-jffd-quiz-guest-name]');
      var timeEl = document.querySelector('[data-jffd-quiz-guest-timeframe]');
      if (!guest) return { ok: false, reason: 'no-guest-ui' };

      var nums = fillGuestPopup(payload, data);
      if (nameEl) nameEl.textContent = nums.petName;
      bindGuestAddLink(data);
      guest.hidden = false;
      setLoggedInPetCardHidden(true);
      /* 2026-09-18, Mary's second QA round: hide the "How much should I feed my dog" link once
         the pet card is on screen. The quiz it opens is already complete for this visitor, so
         Digioh resumes it on its final step, which just re-shows the completion screen and looks
         broken. The card's own Edit pet button is the way back in from here. */
      setQuizLinkHidden(true);

      var duration = formatTimeframe(extras && extras.days);
      var pack = packLabel(extras && extras.packCount, extras && extras.variantTitle);
      if (timeEl) {
        if (extras && extras.packCount) {
          timeEl.textContent = nums.petName + ' should eat the ' + pack + ' about every ' + duration + '.';
        } else if (nums.calories) {
          timeEl.textContent = nums.petName + ' needs about ' + nums.calories + ' calories per day.';
        } else {
          timeEl.textContent = '';
        }
      }

      if (openDialog) openGuestDialog();
      return { ok: true, calories: nums.calories, ozPerDay: nums.ozPerDay, cups: nums.cupsDisplay, petName: nums.petName };
    }

    function showQuizRecommendation(payload, extras) {
      extras = extras || {};
      var data = packConfig();
      if (data.loggedIn) {
        var petDetails = document.querySelector('pet-feeding-details');
        if (petDetails && typeof petDetails.applyQuizResult === 'function') {
          petDetails.applyQuizResult(payload, { openDialog: false });
        }
        var loggedResult = { ok: true, loggedIn: true, petName: payload && payload.dogName };
        window.jffdPdpQuizLastRecommendation = loggedResult;
        return loggedResult;
      }
      var guestResult = showGuestRecommendation(payload, extras, data, extras.openDialog === true);
      window.jffdPdpQuizLastRecommendation = guestResult;
      return guestResult;
    }

    window.__jffdShowQuizRecommendation = showQuizRecommendation;

    function firstValue(source, keys) {
      if (!source || typeof source !== 'object') return '';
      for (var i = 0; i < keys.length; i += 1) {
        if (source[keys[i]] !== undefined && source[keys[i]] !== null && source[keys[i]] !== '') {
          return source[keys[i]];
        }
      }
      var nested = [source.snapshot, source.latestSnapshot, source.currentSnapshot, source.pet];
      for (var j = 0; j < nested.length; j += 1) {
        var value = firstValue(nested[j], keys);
        if (value !== '') return value;
      }
      return '';
    }

    function normalizedActivity(value) {
      var text = String(value || '').toLowerCase();
      if (text.indexOf('light') !== -1) return 'Light';
      if (text.indexOf('high') !== -1) return 'High';
      if (text.indexOf('moderate') !== -1) return 'Moderate';
      return '';
    }

    function normalizedBodyType(value) {
      var text = String(value || '').toLowerCase();
      if (text.indexOf('skinny') !== -1) return 'Skinny';
      if (text.indexOf('just') !== -1 || text.indexOf('ideal') !== -1) return 'Just Right';
      if (text.indexOf('husky') !== -1) return 'Husky';
      if (text.indexOf('chubby') !== -1) return 'Chubby';
      return '';
    }

    function normalizedNeutered(value) {
      if (value === true) return 'Yes';
      if (value === false) return 'No';
      var text = String(value || '').toLowerCase();
      if (text === 'yes' || text === 'true' || text === '1' || text === 'spayed' || text === 'neutered') return 'Yes';
      if (text === 'no' || text === 'false' || text === '0' || text === 'intact') return 'No';
      return '';
    }

    function normalizedPortion(value) {
      var text = String(value || '').toLowerCase().replace(/[_\s]+/g, '-');
      if (text.indexOf('half') !== -1) return 'half-bowl';
      if (text.indexOf('top') !== -1) return 'topping';
      return 'full-bowl';
    }

    function birthdayPart(source, part) {
      var direct = firstValue(
        source,
        part === 'month'
          ? ['birthMonth', 'birth_month', 'petBirthMonth', 'custom_41']
          : ['birthYear', 'birth_year', 'petBirthYear', 'custom_42']
      );
      if (direct !== '') return direct;
      var dateValue = firstValue(source, ['birthday', 'birthdate', 'birthDate', 'birth_date', 'dateOfBirth', 'date_of_birth', 'dob']);
      if (!dateValue) return '';
      var parsed = new Date(dateValue);
      if (Number.isNaN(parsed.getTime())) return '';
      return part === 'month' ? parsed.getUTCMonth() + 1 : parsed.getUTCFullYear();
    }

    /* 2026-09-18: flatten before reading.

       firstValue only looks at top-level keys, but the logged-in card's #editPayload() hands us
       a NESTED object: { snapshot, pet, dogName, calories }. Weight, neutered, bodyType,
       activity, portion and the birthday all live inside snapshot or pet, so every one of them
       normalized to '' and those empties were then written into the data layer on open (which is
       deliberate, to clear the previous dog). That left the API fetch in Custom JS 26244 as the
       only thing that could ever fill the form, so a slow or failed fetch showed a blank one.

       Order matters: pet first, then snapshot, then the top level, so the most specific value
       wins. Nested objects are skipped rather than flattened recursively, which keeps this
       predictable and avoids clobbering a scalar with an object. */
    function flattenEditSource(source) {
      source = source || {};
      var merged = {};
      [source.pet, source.snapshot, source].forEach(function (part) {
        if (!part || typeof part !== 'object') return;
        Object.keys(part).forEach(function (key) {
          var value = part[key];
          if (value === null || value === undefined || value === '' || typeof value === 'object') return;
          merged[key] = value;
        });
      });
      return merged;
    }

    function editorPayload(source) {
      source = flattenEditSource(source);
      return {
        dogName: firstValue(source, ['dogName', 'name', 'petName', 'custom_3']),
        calories: firstValue(source, ['calories', 'caloriesRequiredPerDay', 'dailyCalories', 'latestCaloriesRequiredPerDay', 'custom_45']),
        weight: firstValue(source, ['weight', 'weightLb', 'weightPounds', 'petWeight', 'latestPetWeight', 'custom_11']),
        neutered: normalizedNeutered(firstValue(source, ['neutered', 'sterilized', 'isNeutered', 'spayedNeutered', 'petNeutered', 'latestPetNeutered', 'custom_7'])),
        bodyType: normalizedBodyType(firstValue(source, ['bodyType', 'bodyCondition', 'idealBodyType', 'petBodyType', 'latestPetBodyType', 'custom_43'])),
        activity: normalizedActivity(firstValue(source, ['activity', 'activityLevel', 'petActivityLevel', 'latestPetActivityLevel', 'exercise', 'custom_10'])),
        portion: normalizedPortion(firstValue(source, ['portion', 'portionSelection', 'petPortionSelection', 'latestPetPortionSelection', 'custom_44'])),
        birthMonth: birthdayPart(source, 'month'),
        birthYear: birthdayPart(source, 'year'),
        sex: firstValue(source, ['sex', 'gender', 'custom_6'])
      };
    }

    window.__jffdNormalizePdpEditPayload = editorPayload;

    // Persists an Edit Pet save to the Partner API. Deliberately does NOT
    // touch the pill or PDP commerce state until the API confirms the save:
    // on success it refreshes the pet from the API (not the locally-computed
    // payload) so the card reflects what was actually persisted; on failure
    // it leaves the existing pill alone. Campaign 334877 (the Digioh editor)
    // is responsible for staying open on failure; it can listen for the
    // 'jffd:pdp-pet-edit-result' event once that wiring is in place.
    window.__jffdSaveLoggedInPetEdit = function (data) {
      data = data || {};
      var payload = editorPayload(data);
      payload.calories = payload.calories || data.calories || '';
      var petDetails = document.querySelector('pet-feeding-details');
      var petId = data.petId || (petDetails && petDetails.currentPetId);

      if (!petId) {
        // No pet to save against (e.g. a logged-in shopper reached the
        // guest intake quiz). Nothing to persist, so apply the computed
        // result locally the same way the guest flow does.
        if (typeof window.__jffdApplyPdpQuizResult === 'function') {
          window.__jffdApplyPdpQuizResult(data, { skipDialog: true });
        }
        return Promise.resolve({ ok: true, reason: 'no-pet-id-digioh-pipeline', payload: payload });
      }

      return fetch(
        '/apps/api-proxy/partner/pets/' + encodeURIComponent(petId) + '/snapshots',
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            sterilized: payload.neutered === 'Yes',
            weight: Number(payload.weight),
            bodyType: payload.bodyType,
            activityLevel: payload.activity,
            portionSelection: payload.portion,
            caloriesRequiredPerDay: Number(payload.calories)
          })
        }
      ).then(function (response) {
        if (!response.ok) throw new Error('Pets and Vets could not save this update.');
        window.jffdPdpPetEditLastError = undefined;
        if (petDetails && typeof petDetails.refreshPets === 'function') {
          petDetails.refreshPets();
        }
        window.dispatchEvent(new CustomEvent('jffd:pdp-pet-edit-result', {
          detail: { ok: true, petId: petId }
        }));
        return { ok: true, payload: payload };
      }).catch(function (error) {
        window.jffdPdpPetEditLastError = (error && error.message) || 'save-failed';
        window.dispatchEvent(new CustomEvent('jffd:pdp-pet-edit-result', {
          detail: { ok: false, petId: petId, error: window.jffdPdpPetEditLastError }
        }));
        return { ok: false, error: window.jffdPdpPetEditLastError };
      });
    };

    var detailsBtn = document.querySelector('[data-jffd-quiz-guest-details]');
    var nameBtn = document.querySelector('[data-jffd-quiz-guest-open]');
    var editBtn = document.querySelector('[data-jffd-quiz-guest-edit]');
    var closeBtn = document.querySelector('[data-jffd-quiz-guest-close]');
    var guestDialog = document.getElementById('jffd-pdp-quiz-guest-dialog');
    if (detailsBtn) {
      detailsBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openGuestDialog();
      });
    }
    if (nameBtn) {
      nameBtn.addEventListener('click', function (event) {
        event.preventDefault();
        openGuestDialog();
      });
    }
    if (editBtn) {
      editBtn.addEventListener('click', function (event) {
        event.preventDefault();
        var stored = window.jffdPdpQuizLastLayer;
        if (!stored) {
          try { stored = JSON.parse(window.localStorage.getItem('jffd-pdp-quiz:pet') || 'null'); } catch (e) {}
        }
        var tries = 0;
        (function attempt() {
          if (typeof window.__jffdOpenPdpQuizForEdit === 'function') {
            window.__jffdOpenPdpQuizForEdit({ mode: 'guest', payload: stored || {} });
            return;
          }
          tries += 1;
          if (tries < 40) setTimeout(attempt, 100);
        })();
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeGuestDialog);
    if (guestDialog) {
      guestDialog.addEventListener('click', function (event) {
        if (event.target === guestDialog) closeGuestDialog();
      });
    }
    bindGuestAddLink(packConfig());

    function restoreStoredQuiz() {
      if (typeof window.__jffdApplyPdpQuizResult !== 'function') return;
      var storedPet;
      var storedHandle;
      var data = packConfig();
      if (data.loggedIn) return;
      try { storedPet = JSON.parse(window.localStorage.getItem('jffd-pdp-quiz:pet') || 'null'); } catch (e) { storedPet = null; }
      try {
        storedHandle = data.handle
          ? JSON.parse(window.localStorage.getItem('jffd-pdp-quiz:' + data.handle) || 'null')
          : null;
      } catch (e) { storedHandle = null; }
      var stored = Object.assign({}, storedPet || {}, storedHandle || {});
      if (!stored.calories && !stored.dogName) return;
      window.__jffdApplyPdpQuizResult(stored, { skipDialog: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', restoreStoredQuiz);
    } else {
      restoreStoredQuiz();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
